import {useEffect} from "react";
import {Controller, useForm} from "react-hook-form";

import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import {Box} from "@material-ui/core";
import {quotationFilteringAction} from "../features/sliceReducer/myProjectReducer";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../features/store";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      marginLeft: "26px",
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  })
);

const QuotationFilter = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {quotationFiltering} = useSelector(
    (state: RootState) => state.myProject
  );

  const {handleSubmit, control, watch} = useForm();

  const {preYear, type} = watch();

  const onSubmit = handleSubmit((filter) => console.log(filter));

  useEffect(() => {
    dispatch(quotationFilteringAction({preYear, type}));
  }, [preYear, type]);

  return (
    <form onSubmit={onSubmit}>
      <Box>
        <FormControl className={classes.formControl}>
          <InputLabel id="year">검색연도</InputLabel>
          <Controller
            name="preYear"
            control={control}
            defaultValue={quotationFiltering.preYear}
            render={({field}) => (
              <Select
                {...field}
                labelId="검색연도"
                id="preYear"
                label="검색연도"
              >
                <MenuItem selected value={0}>
                  전체연도
                </MenuItem>
                <MenuItem value={1}>1년전</MenuItem>
                <MenuItem value={2}>2년전</MenuItem>
                <MenuItem value={3}>3년전</MenuItem>
              </Select>
            )}
          />
        </FormControl>
        <FormControl className={classes.formControl}>
          <InputLabel id="type">검색항목</InputLabel>
          <Controller
            name="type"
            control={control}
            defaultValue={quotationFiltering.type}
            render={({field}) => (
              <Select {...field} labelId="type" id="type" label="검색항목">
                <MenuItem selected value={0}>
                  일반
                </MenuItem>
                <MenuItem value={1}>법규</MenuItem>
                <MenuItem value={2}>지침</MenuItem>
                <MenuItem value={3}>권고</MenuItem>
              </Select>
            )}
          />
        </FormControl>
      </Box>
    </form>
  );
};

export default QuotationFilter;
